// extracted by mini-css-extract-plugin
export default {"errorText":"pYZ87qiQ","errorIconWrapper":"l7Wsd_9q","error":"SaxDbiTN","errorIcon":"ehv23EiH"};